interface FileTypes {
  JPG: string;
  PNG: string;
  JPEG: string;
}

const Types: FileTypes = {
  JPG: 'JPG',
  PNG: 'PNG',
  JPEG: 'JPEG',
};

export default Types;
